export const home = '/';
// export const about = '/about';
// export const setting = '/setting';
export const translation = '/translation';
export const translationAlt = '/translate';
export const guides = '/guides';
export const createGuide = '/guide-create';
export const editGuideParam = ':id';
export const editGuide = `/guide-edit/${editGuideParam}`;
export const stats = '/stats';